export default __webpack_public_path__ + "static/media/szuzermek_budapest_modra.2eb20a0e.jpg";